import { createDomain, sample } from 'effector'
import { FormValues } from '~/entities/Employee/model'
import { AxiosErrorType, Employee } from '~/shared/api'
import { backFx } from '~/shared/lib/history'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { isString } from '~/shared/lib/utils'

export const domain = createDomain('features.employees.add')

export const createFx = domain.createEffect<
  FormValues,
  Employee,
  AxiosErrorType
>({
  async handler(values) {
    const { rolesIds, timezone, ...attrs } = values
    const employee = new Employee({
      ...attrs,
      ...(isString(timezone) && { timezone }),
    })

    if (Array.isArray(rolesIds)) employee.setRoles(rolesIds)

    const result = await employee.save()
    return result.getModel() as Employee
  },
})

export const formSubmitted = domain.createEvent<FormValues>()
sample({
  clock: formSubmitted,
  target: createFx,
})

sample({
  clock: createFx.doneData,
  fn() {
    return {
      message: 'Пользователь создан',
      variant: 'success' as const,
    }
  },
  target: [snackbarEnqueued, backFx],
})
sample({
  clock: createFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})
